'use client';

import { c as _c } from "react/compiler-runtime";
import { unwrapFromResult } from '@shared/utils/helpers/resultWrapper';
import toast from '@shared/utils/helpers/toast';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { PLATFORM_BRAND } from '../../utils/platformBrand';
import { client } from '../../utils/trpc';
import AppCard from './AppCard';
import { useOAuthReturn } from './useOAuthReturn';
type Props = {
  autoEnabled: boolean;
  issue?: boolean;
  onToggleAuto: () => void;
};
const InstagramCard = t0 => {
  const $ = _c(13);
  const {
    autoEnabled,
    issue,
    onToggleAuto
  } = t0;
  const queryClient = useQueryClient();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      queryKey: ["instagramHasToken"],
      queryFn: _temp,
      retry: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    data: status,
    isLoading
  } = useQuery(t1);
  let t2;
  if ($[1] !== queryClient) {
    t2 = async (code, state) => {
      const [error] = await client.platforms.instagram.connect.mutate({
        code,
        state
      });
      if (error) {
        toast(error.message || "Failed to connect Instagram");
        return;
      }
      toast("Instagram connected successfully");
      await queryClient.invalidateQueries({
        queryKey: ["instagramHasToken"]
      });
    };
    $[1] = queryClient;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useOAuthReturn("instagram", "Instagram", t2);
  const connect = _temp2;
  let t3;
  if ($[3] !== queryClient) {
    t3 = async () => {
      const [error_1] = await client.platforms.instagram.disconnect.mutate();
      if (error_1) {
        toast(error_1.message || "Failed to disconnect Instagram");
        return;
      }
      toast("Instagram account disconnected.");
      await queryClient.invalidateQueries({
        queryKey: ["instagramHasToken"]
      });
    };
    $[3] = queryClient;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const disconnect = t3;
  const t4 = !!status?.hasToken;
  const t5 = status?.username ? `Connected as @${status.username}` : undefined;
  let t6;
  if ($[5] !== autoEnabled || $[6] !== disconnect || $[7] !== isLoading || $[8] !== issue || $[9] !== onToggleAuto || $[10] !== t4 || $[11] !== t5) {
    t6 = <AppCard label="Instagram" brand={PLATFORM_BRAND.INSTAGRAM} loading={isLoading} connected={t4} accountText={t5} supports="Cross-posts photos, carousels and Reels" note="Requires a Professional account (Business or Creator). Free to switch in Instagram Settings > Account > Switch to Professional Account." autoEnabled={autoEnabled} issue={issue} onConnect={connect} onDisconnect={disconnect} onToggleAuto={onToggleAuto} />;
    $[5] = autoEnabled;
    $[6] = disconnect;
    $[7] = isLoading;
    $[8] = issue;
    $[9] = onToggleAuto;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default InstagramCard;
function _temp() {
  return unwrapFromResult(client.platforms.instagram.hasToken.query());
}
async function _temp2() {
  const [error_0, data] = await client.platforms.instagram.getAuthUrl.query();
  if (error_0 || !data?.url) {
    toast("Failed to start Instagram connection");
    return;
  }
  window.location.href = data.url;
}